// extracted by mini-css-extract-plugin
export default {"imgdiv":"_66efa61bf0 _7636e33410","img":"c4d04b65a2 f08733cc2e"};